import { render, staticRenderFns } from "./OpenBrokerageSearch.vue?vue&type=template&id=3dcdc387"
import script from "./OpenBrokerageSearch.vue?vue&type=script&lang=ts"
export * from "./OpenBrokerageSearch.vue?vue&type=script&lang=ts"
import style0 from "./OpenBrokerageSearch.vue?vue&type=style&index=0&id=3dcdc387&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports